import { getServerTimestamp } from '../../../Services/@sgorg/game-backend-client-mock';

export class UI_EventPostcard extends Phaser.Group {
  constructor(config) {
    super(game);

    this._container = new G.Button(0, 0, 'eventPostcardWorldMap', this.openCoinShop, this);

    this._ready = {
      drawing: false,
      text: false,
    };

    if (G.featureUnlock.eventPostcard.range) {
      this.makeTimerText();
    } else {
      this._ready.text = true;
    }

    this._ready.drawing = true;
    this.show();
  }

  openCoinShop() {
    if (!G.IAP) {
      if (G.saveState.isMsgRead(G.OMTsettings.postcardEvent.eventId)) {
        G.sb('pushWindow').dispatch('eventPostcard', false, G.WindowMgr.LayerNames.Base);
      } else {
        G.sb('pushWindow').dispatch('eventPostcardPromo', false, G.WindowMgr.LayerNames.Base);
      }
    } else {
      G.sb('pushWindow').dispatch(['coinShop', { hideFreeGift: false }]);
    }
  }

  show() {
    if (this._ready.drawing && this._ready.text) {
      this._container.scale.set(0.01);
      this.addChild(this._container);
      game.add.tween(this._container.scale).to({ x: 1, y: 1 }, 250, Phaser.Easing.Sinusoidal.InOut, true);
    }
  }

  async makeTimerText() {
    const curTime = await getServerTimestamp();
    const endTime = G.featureUnlock.eventPostcard.range.end;
    this._timer = new G.TextTimer(-5, 10, null, {
      style: 'font-num-blue',
      fontSize: 30,
    }, 0.5, this._container.width);
    this._timer.setSecLeft((endTime - curTime) / 1000);
    this._timer.active = true;
    this._container.addChild(this._timer);
    this._ready.text = true;
    this.show();
  }
}
